/**
 * Shared Drive folders for the Pilots page. They live in the team's "Pilots"
 * shared drive: FDEs Knowledge is open to anyone with the link, the rest to
 * members of the shared drive.
 */

export const PILOT_RESOURCES = [
  {
    key: "templates",
    label: "Pilot templates",
    url: "https://drive.google.com/drive/folders/1cUS4QB01e-MXqijJj8-fINclQPAiwJpg",
  },
  {
    key: "masterPlan",
    label: "Master plan",
    url: "https://drive.google.com/drive/folders/14yoYYaGEI7aW8CNhPRPQNmSD5iK5wqW1",
  },
  {
    key: "pilots",
    label: "All pilot files",
    url: "https://drive.google.com/drive/folders/1J8zF6zzdICZ_CwZjhGeZTjSqsKVyXXF_",
  },
];

export const FDE_RESOURCES = [
  {
    key: "knowledge",
    label: "FDEs Knowledge folder",
    url: "https://drive.google.com/drive/folders/1CUGwwecKelkuu-ukTQL8B6niVCxKICev?usp=sharing",
  },
  {
    key: "playbook",
    label: "FDE Playbook v2",
    url: "https://drive.google.com/file/d/1BTtFO-P3zHUG-CbGfJOAXG-RXdQbXJt2/view",
  },
];
